import React from 'react';
import HelpTooltip from './HelpTooltip'

const MetricWidget = (props) => {

    let section = "state-overview";
    let bg = props.colour;
    let fg = "white";
    let text = "white";

    if (props.alt) {
        section = "state-overview state-alt";
        bg = `${props.colour.charAt(0)}-border`;
        fg = props.colour;
        text = "";
    }

    return (
        <section className={section}>
            <div className={`panel ${bg}`}>
                <div className="symbol">
                    <span className={fg}>
			<i className={`fa ${props.icon}`}></i>
                    </span>
                </div>
                <div className={`value ${text}`}>
		    <h1 className="timer">{props.value}</h1> 
		    <p>
			{props.title}
			<HelpTooltip placement='left' heading={props.name}/>
		    </p>
                </div>
            </div>
        </section>
    );

}

export default MetricWidget;
